import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { RequestInformationFatturaPaComponent } from './request-information-fattura-pa';


// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.request-information-fattura-pa', {
            url: '/request-information-fattura-pa',
            ncyBreadcrumb: {
                label: 'Richiesta Informazioni Fattura Elettronica',
                parent: 'home.fatturazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Richiesta Informazioni Fattura Elettronica'
            },
            'views': {
                'homeContent': {
                    template: '<request-information-fattura-pa flex="100"></request-information-fattura-pa>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const RequestInformationFatturaPaModule: string = ng
    .module('request-information-fattura-pa', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('requestInformationFatturaPa', RequestInformationFatturaPaComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/request-information-fattura-pa/request-information-fattura-pa.module.ts